module.exports = __webpack_public_path__ + "static/img/255_TO8_2263_og.cfa5359.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/255_TO8_2263_og.jpg
// module id = s9KI
// module chunks = 0